import Drawer from 'Components/Drawer';
import Panel from 'Components/Panel';
import Table from 'Components/SimpleTable';
import { sortBy } from 'lodash';
import ShowIndicator from 'Pages/Indicators/Show';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import findWhere from 'selectors/findWhere';
import { unixToDate } from 'utils/date';

const
    columns = [
        { label: 'ID', dataKey: 'id' },
        { label: 'Name', dataKey: 'name' },
        {
            label: 'Last Update',
            dataKey: 'updated_at',
            transform: model => `${model.updater_name} @ ${unixToDate(model.updated_at)}`
        }
    ];

const Component = props => {
    const { siteId } = props;

    const [currentIndicator, setCurrentIndicator] = useState(null);

    const indicatorIds = useSelector(state => state.indicators.ids);
    const indicatorModels = useSelector(state => state.indicators.models);

    const onClose = () => setCurrentIndicator(null);

    let drawer;
    if (currentIndicator) {
        drawer = <ShowIndicator closeDrawer={onClose} id={currentIndicator}/>;
    }

    const indicators = sortBy(
        findWhere(
            indicatorIds.map(id => indicatorModels[id]),
            { site_id: siteId }
        ),
        'name'
    );

    return (
        <Panel>
            <Drawer big={!!currentIndicator} onClose={onClose} open={!!currentIndicator}>
                {drawer}
            </Drawer>
            <Table columns={columns} onRowClick={indicatorId => setCurrentIndicator(indicatorId)} rows={indicators}/>
        </Panel>
    );
};

export default Component;
